export function formatNumber(number) {
    // 将数字转换为字符串
    let strNumber = number.toString();

    // 使用正则表达式在数字字符串中插入逗号
    let formattedNumber = strNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return formattedNumber;
}